<template>
  <div class="surface-builder">
    <a v-if="isBuilderRegistered"
       :href="builderProfileUrl"
       target="_blank"
       class="builder-id caption-type"
       @click="trackProfileClick">
      <avatar-image class="builder-avatar"
                    :user="builder"
                    :width="16"
                    :height="16" />
      <span class="builder-name">{{ builderName }}</span>
    </a>
    <div v-else class="builder-id caption-type">
      <avatar-image class="builder-avatar" :width="16" :height="16" />
      <span class="builder-name caption-type" v-t>Anonymous</span>
    </div>
    <div v-if="contributorCount > 0"
         class="builder-contributors"
         :title="contributorText"
         @click="showContributorsList">
      &nbsp;+&nbsp;<span class="builder-contributors-count caption-type">
        {{ contributorCount }}
      </span>
    </div>
    <div class="builder-separator">&#9679;</div>
    <relative-time class="builder-time caption-type" :datetime="wallUpdatedAt" />
    <surface-contributors v-if="xContributorsList" />
  </div>
</template>

<script>
import SurfaceContributors from 'vuecomponents/surface_contributors'
import AvatarImage from 'vuecomponents/avatar_image'
import RelativeTime from 'vuecomponents/relative_time'
import t from 'vuedirectives/t'
import { n__ } from 'bits/intl'
import uniq from 'lodash.uniq'
import { trackEvent } from 'bits/analytics'
import { mapGetters, mapState } from 'vuex'

export default {
  components: { AvatarImage, RelativeTime, SurfaceContributors },
  directives: { t },
  computed: {
    ...mapGetters(['builder', 'wallUpdatedAt']),
    ...mapState(['xContributorsList']),
    ...mapGetters('post', ['postsArray']),
    builderName () {
      return this.builder.name || this.builder.username
    },
    builderProfileUrl () {
      return '/' + this.builder.username
    },
    isBuilderRegistered () {
      return this.builder.registered
    },
    contributorCount () {
      const authors = this.postsArray.map(x => x.author_id)
      const nonBuilderAuthors = authors.filter(x => x !== this.builder.id)
      return uniq(nonBuilderAuthors).length
    },
    contributorText () {
      // TODO
      return n__('%{num} contributor', '%{num} contributors', this.contributorCount, { num: this.contributorCount })
    }
  },
  methods: {
    showContributorsList () {
      trackEvent('Surface', 'Title Clicked', 'Contributor List')
      this.$store.dispatch('showContributorsList')
    },
    trackProfileClick () {
      trackEvent('Surface', 'Title Clicked', 'Builder Profile')
    }
  }
}
</script>
